import { useState } from 'react';
import {
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    EmailShareButton,
    LinkedinShareButton,
    TelegramShareButton,
    FacebookIcon,
    TwitterIcon,
    WhatsappIcon,
    EmailIcon,
    LinkedinIcon,
    TelegramIcon,
} from 'react-share';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Copy, Check } from 'lucide-react';

const ShareCourseDialog = ({ open, onOpenChange, course }) => {
    const [copied, setCopied] = useState(false);

    // Construct the share URL (adjust based on your routing)
    const courseUrl = `${window.location.origin}/cover-course/${course?.slug}`;
    const courseTitle = course?.title || 'Check out this course!';
    const courseDescription = course?.description || 'Learn something new today!';

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(courseUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    // Native share for mobile devices
    const handleNativeShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: courseTitle,
                    text: courseDescription,
                    url: courseUrl,
                });
            } catch (err) {
                if (err.name !== 'AbortError') {
                    console.error('Error sharing:', err);
                }
            }
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md p-4 border border-neutral-300">
                <DialogHeader>
                    <DialogTitle>Share Course</DialogTitle>
                </DialogHeader>

                <div className="flex flex-col gap-4 py-4 px-2">
                    {/* Social Media Icons */}
                    <div className="flex gap-3 justify-center flex-wrap">
                        <FacebookShareButton url={courseUrl} quote={courseTitle} blankTarget={true}>
                            <FacebookIcon size={40} round />
                        </FacebookShareButton>

                        <TwitterShareButton url={courseUrl} title={courseTitle} blankTarget={true}>
                            <TwitterIcon size={40} round />
                        </TwitterShareButton>

                        <WhatsappShareButton url={courseUrl} title={courseTitle} blankTarget={true}>
                            <WhatsappIcon size={40} round />
                        </WhatsappShareButton>

                        <LinkedinShareButton url={courseUrl} blankTarget={true}>
                            <LinkedinIcon size={40} round />
                        </LinkedinShareButton>

                        <TelegramShareButton url={courseUrl} title={courseTitle} blankTarget={true}>
                            <TelegramIcon size={40} round />
                        </TelegramShareButton>

                        <EmailShareButton
                            url={courseUrl}
                            subject={courseTitle}
                            body={courseDescription}
                            blankTarget={true}
                        >
                            <EmailIcon size={40} round />
                        </EmailShareButton>
                    </div>

                    {/* Copy Link Button */}
                    <Button onClick={handleCopyLink} variant="outline" className="w-full">
                        {copied ? (
                            <>
                                <Check className="mr-2 h-4 w-4" />
                                Copied!
                            </>
                        ) : (
                            <>
                                <Copy className="mr-2 h-4 w-4" />
                                Copy Link
                            </>
                        )}
                    </Button>

                    {/* Native Share Button (for mobile) */}
                    {navigator.share && (
                        <Button onClick={handleNativeShare} variant="ghost" className="w-full">
                            More Options
                        </Button>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ShareCourseDialog;
